import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { ImageCroppedEvent, ImageTransform } from 'ngx-image-cropper';

@Component({
  selector: 'app-crop-avatar',
  templateUrl: './crop-avatar.component.html',
  styleUrls: ['./crop-avatar.component.scss'],
})
export class CropAvatarComponent implements OnInit {
  croppedImageBase64: string = "";
  croppedImageFile: File;
  @Input() aspectRatio: any = 1/1;
  @Input() maintainAspectRatio: boolean = true;
  @Input() readyToCropImage: any = '';
  @Input() imageFormat: string = 'png';
  @Output() imageCropDone: EventEmitter<any> = new EventEmitter<any>();
  @Output() imageCropCancel: EventEmitter<void> = new EventEmitter<void>();
  rotation = 0;
  transform: ImageTransform = {};

  constructor() { }

  ngOnInit() { }

  imageCropped(event: ImageCroppedEvent) {
    this.croppedImageBase64 = event.base64;
    const blob = this.dataURItoBlob(event.base64);
    this.croppedImageFile = new File([blob], 'cropped-image.jpeg', { type: 'image/jpeg' });
  }

  done() {
    this.imageCropDone.emit(this.croppedImageFile);
  }

  cancel() {
    this.imageCropCancel.emit();
  }

  rotateRight() {
    this.rotation += 90;
    this.updateRotation();
  }

  updateRotation() {
    this.transform = {
      ...this.transform,
      rotate: this.rotation,
    };
  }

  private dataURItoBlob(dataURI: string): Blob {
    const byteString = atob(dataURI.split(',')[1]);
    const mimeString = dataURI.split(',')[0].split(':')[1].split(';')[0];
    const ab = new ArrayBuffer(byteString.length);
    const ia = new Uint8Array(ab);
    for (let i = 0; i < byteString.length; i++) {
      ia[i] = byteString.charCodeAt(i);
    }
    return new Blob([ab], { type: mimeString });
  }
}
